/**
 * Created by staffanrantzow on 14/04/16.
 */

import { proxyCounterpart } from '../../scripts/proxyCounterpart';

export default class InvoiceEntity {

  constructor (
    id,
    allowance,
    amount,
    approvalStatus,
    createdAt,
    currencyAmount,
    currencyName,
    currencyExchangeRate,
    currencyId,
    expense,
    fullPaymentDateTime,
    gross,
    hasCreditErrand,
    invoiceNumber,
    loyaltyPoints,
    net,
    paymentStatus,
    preReport,
    preReportedAt,
    sendToEmail,
    sent,
    specification,
    status,
    supplierLedgerDateTime,
    taxId,
    taxPercent,
    travel,
    userId,
    customer,
    currency,
    hours,
    invoiceUsers,
    pdfLink,
    hsd,
    displayDates,
    displayHours,
    salaries,
    invoiceDates,
    calculation,
    ocr,
    uuid,
    users,
    messageType,
    billingEmails,
    eInvoiceEmail,
    surveys,
    poNumber,
    companyPhone,
  ) {
    this.id = id;
    this.allowance = allowance;
    this.amount = amount;
    this.approvalStatus = approvalStatus;
    this.createdAt = createdAt;
    this.currencyExchangeRate = currencyExchangeRate;
    this.currencyId = currencyId;
    this.currencyAmount = currencyAmount;
    this.currencyName = currencyName;
    this.expense = expense;
    this.fullPaymentDateTime = fullPaymentDateTime;
    this.gross = gross;
    this.hasCreditErrand = hasCreditErrand;
    this.invoiceNumber = invoiceNumber;
    this.loyaltyPoints = loyaltyPoints;
    this.net = net;
    this.paymentStatus = paymentStatus;
    this.preReport = preReport;
    this.preReportedAt = preReportedAt;
    this.sendToEmail = sendToEmail;
    this.sent = sent;
    this.specification = specification;
    this.status = status;
    this.supplierLedgerDateTime = supplierLedgerDateTime;
    this.taxId = taxId;
    this.taxPercent = taxPercent;
    this.travel = travel;
    this.userId = userId;
    this.customer = customer;
    this.currency = currency;
    this.hours = hours;
    this.invoiceUsers = invoiceUsers;
    this.pdfLink = pdfLink;
    this.hsd = hsd;
    this.displayDates = displayDates;
    this.displayHours = displayHours;
    this.salaries = salaries;
    this.invoiceDates = invoiceDates;
    this.calculation = calculation;
    this.ocr = ocr;
    this.uuid = uuid;
    this.users = users;
    this.messageType = messageType;
    this.billingEmails = billingEmails;
    this.eInvoiceEmail = eInvoiceEmail;
    this.surveys = surveys;
    this.poNumber = poNumber;
    this.companyPhone = companyPhone;
  }

  get currencyValue () {
    if (this.currency) {
      return this.amount / this.currency.exchangeRate;
    }

    return 0;
  }

  get statusText () {
    switch (this.status) {
      case 1:
        return proxyCounterpart('WITH_RES');
      case 2:
        return proxyCounterpart('APPROVED');
      case 3:
        return proxyCounterpart('NOT_APPROVED');
      case 4:
        return proxyCounterpart('WAIT_JUDGEMENT');
    }
  }

  get paymentStatusText () {
    switch (this.paymentStatus) {
      case 1:
        return proxyCounterpart('NOT_PAID');
      case 2:
        return proxyCounterpart('IS_PAID');
      case 3:
        return proxyCounterpart('PART_PAID');
    }
  }

  get approvalStatusText () {
    switch (this.approvalStatus) {
      case 1:
        return proxyCounterpart('WAIT_JUDGEMENT');
      case 2:
        return proxyCounterpart('APPROVED');
      case 3:
        return proxyCounterpart('NOT_APPROVED');
      case 4:
        return proxyCounterpart('APPROVED_WITH_RES');
      case 5:
        return proxyCounterpart('PREREGISTERED');
      default:
        return '';
    }
  }

}



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/invoices/invoice-entity.js
 **/